import { Box, Flex, Text } from '@chakra-ui/react';
import { EventFeedback } from 'model/modules/events/eventCategory';
import parseUrl from 'parse-url';
import AppCard from 'presentation/components/shared/card/AppCard';
import GridHeading from 'presentation/components/shared/grid/GridHeading';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import YouTube from 'react-youtube';

interface Props {
  videoReviews: EventFeedback[];
}

const EventDetailVideoReviews: FC<Props> = ({ videoReviews }) => {
  const { t } = useTranslation();
  const gap = 20;

  return (
    <>
      <GridHeading>{t('eventVideoReviews')}</GridHeading>
      <Flex justifyContent="space-between" flexWrap="wrap">
        {videoReviews.map((review, index) => {
          const parsedUrl = parseUrl(review.videoUrl);

          return (
            <AppCard
              key={index}
              w={`calc(50% - ${gap / 2}px)`}
              overflow="hidden"
              mb="20px"
            >
              <YouTube
                videoId={parsedUrl.query['v']}
                opts={{
                  width: '100%',
                  height: '156px',
                }}
              />
              <Box h="96px" p="20px">
                <Text mb="5px" fontSize="20px" fontWeight={700} noOfLines={1}>
                  {review.clientName}
                </Text>
                <Text fontSize="14px" noOfLines={2}>
                  {review.description}
                </Text>
              </Box>
            </AppCard>
          );
        })}
      </Flex>
    </>
  );
};

export default EventDetailVideoReviews;
